module.exports = __webpack_public_path__ + "img/banner-font.cf8bb86e.png";